const setting = {
  namespaced: true,
  state: {
    // 主题
    dataTheme: "dark",
    // 顶栏是否折叠
    isCollapse: false,
    // 新闻详情内容
    newsContent: "",
    // 屏幕宽度
    screenWidth: 1600,
    // 屏幕高度
    screenHeight: 945,
    // 返回顶部
    backTop: false,
    // 服务器上的设置数据
    settings: {}
  },
  mutations: {
    SET_DATA_THEME: (state, theme) => {
      if (theme) {
        return (state.dataTheme = theme);
      }
      state.dataTheme = state.dataTheme === "light" ? "dark" : "light";
    },
    SET_NEWS_CONTENT: (state, value) => {
      state.newsContent = value;
    },
    SET_COLLAPSE: (state, value) => {
      state.isCollapse = value;
      document.body.style.overflow = value ? "hidden" : "auto";
    },
    SET_WIDTH (state, data) {
      state.screenWidth = data
    },
    SET_HEIGHT (state, data) {
      state.screenHeight = data
    },
    SET_BACKTOP (state, data) {
      state.backTop = data
    },
    SET_SETTINGS (state, data) {
      state.settings = Object.assign({}, data)
    },
  },
  actions: {
    setDataTheme({ commit }, theme) {
      commit("SET_DATA_THEME", theme);
    },
    setNewsContent({ commit }, value) {
      commit("SET_NEWS_CONTENT", value);
    },
    setCollapse({ commit }, value) {
      commit("SET_COLLAPSE", value);
    },
  },
};

export default setting;
